<div (click)="login($event)" id="my-signin1" #container>
  <div [ngClass]="hadErrorInitializing ? 'no-click' : ''" id="my-signin2"></div>
</div>

